import * as THREE from 'three';
import { Entity } from './Entity.js';
import { CONFIG, ASCII_CHARS } from '../core/config.js';

export class EnemyBullet extends Entity {
    constructor(x, y, targetX, targetY, damage, scene) {
        super(x, y, ASCII_CHARS.ENEMY_BULLET, CONFIG.COLORS.ENEMY_BULLET, scene);
        
        this.direction = new THREE.Vector3(targetX - x, 0, targetY - y).normalize();
        this.speed = 8; // Slower than player bullets
        this.damage = damage;
        this.lifetime = 4;
        
        // Visual enhancement for enemy bullets
        this.scale = 0.8;
        this.pulseSpeed = 6;
    }
    
    update(deltaTime, camera, gameState) {
        super.update(deltaTime, camera);
        
        // Move bullet
        this.position.add(this.direction.clone().multiplyScalar(this.speed * deltaTime));
        this.lifetime -= deltaTime;
        
        // Check collision with player
        const player = gameState.player;
        if (player && this.isColliding(player, 1.2)) {
            if (player.takeDamage(this.damage)) {
                gameState.gameOver = true;
            } else {
                gameState.stats.health = Math.max(0, gameState.stats.health - this.damage);
            }
            return true; // Bullet should be destroyed
        }
        
        return this.lifetime <= 0;
    }
    
    updateAnimation(deltaTime) {
        super.updateAnimation(deltaTime);
        
        // Pulsing effect
        this.scale = 0.8 + Math.sin(this.pulseTime * this.pulseSpeed) * 0.2;
    }
} 